var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXlsx64 = function SvgXlsx64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 2048 2048"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1536 928h-224v-96h224m0 256h-224v-96h224m0 256h-224v-96h224m-288-224h-192v-96h192m0 256h-192v-96h192m0 256h-192v-96h192m471-608q9 11 9 23v1321q0 14-9 23t-23 9H384q-14 0-23-9t-9-23v-416H200q-30 0-51-21t-21-51V680q0-30 21-51t51-21h152V160q0-14 9-23t23-9h905q14 0 23 9m0 407h361l-361-361M461 1274l101-186q4 11 11 22l87 164h109l-146-236 143-234H659l-94 183q-3-9-14-32l-76-149H364l138 233-151 235m1345-698h-384q-14 0-23-9t-9-23V160H384v448h536q30 0 51 21t21 51v720q0 30-21 51t-51 21H384v416h1312z",
    className: "xlsx_64_svg__OfficeIconColors_HighContrast"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M384 1904q-16 0-16-16V160q0-16 16-16h905q7 0 12 5l406 406q5 5 5 12v1321q0 16-16 16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#797774",
    d: "M1719 544q9 11 9 23v1321q0 14-9 23t-23 9H384q-14 0-23-9t-9-23V160q0-14 9-23t23-9h905q14 0 23 9m0 407h361l-361-361m384 393h-384q-14 0-23-9t-9-23V160H384v1728h1312z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#21A366",
    d: "M1248 928h-192v-96h192z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M1248 1088h-192v-96h192z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#185C37",
    d: "M1248 1248h-192v-96h192z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#33C481",
    d: "M1536 928h-224v-96h224z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#21A366",
    d: "M1536 1088h-224v-96h224z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#134A2C",
    d: "M1536 1248h-224v-96h224z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M920 1472H200q-30 0-51-21t-21-51V680q0-30 21-51t51-21h720q30 0 51 21t21 51v720q0 30-21 51t-51 21"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m351 1274 151-235-138-233h111l76 149q11 23 14 32l98-181h103l-143 232 146 236H660l-87-164q-7-11-11-22l-101 186z"
  })));
};
export default SvgXlsx64;